import React, { useContext } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import PurchaseOrderProvider from './PurchaseOrders/PurchaseOrderProvider';
import PurchaseOrdersView from './PurchaseOrders/PurchaseOrdersView';
import CostCentres from './CostCentres/CostCentres'
import SpendingOverview from './Spending/SpendingOverview';
import CostExplorer from './Spending/CostExplorer';

import SessionContext from '../context/session'
import CreateSupplierForm from './Suppliers/CreateSupplierForm';

export default function Routes() {

  const sessionContext = useContext(SessionContext)
  const { user } = sessionContext.state

  return (
    <Switch>
      <Route path="/" exact render={() => <Redirect to="/purchase-orders" /> } />
      <Route path="/reports/cost-explorer" exact component={CostExplorer} />
      <Route path="/reports/overview" exact component={SpendingOverview} />
      <Route path="/cost-centres" exact render={(props) => <CostCentres {...props} user={user}/>} />
      <Route path="/suppliers" exact render={(props) => <CreateSupplierForm {...props} user={user} isEditing={true} />} />
      <Route path="/purchase-orders" exact render={(props) => <PurchaseOrdersView {...props} user={user}/>} />
      <Route path="/purchase-orders/:purchaseOrderId" key={window.location.href} render={(props) => <PurchaseOrderProvider {...props} user={user}/>} />
    </Switch>
  )
}
